<template>
    <div 
       class="ivu-vueTree-div" 
        v-show="isShow"
        ref="treeMenu"
        :style="TreeStyle"
        onselectstart="return false">
        <div
            class="vueTreeOverflow" 
            :style="TreeStyle">
        <GiantTree :setting="setting" :nodes="treeData"  @onCreated="handleCreated" :style="ztreeStyle"/>
        </div>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
import GiantTree from "vue-giant-tree";
import $ from 'jquery';
export default {
    name : "fvTree",
    props : ["primitives","fvSystemApi","parentObject"],
    components: {
        GiantTree
    },
    created(){
        this.defaultTailoring = this.parentObject.defaultTailoring;
        this.windowSize = this.parentObject.windowSize;
        this.create();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath,{
            state : {
                $ : this
            }
        });
    },
    data(){
        return {
            TreeStyle :{},              //tree样式
            isShow : true,              //显隐
            isEnable : false,           //禁止
            currentNodes: null,         //选中当前节点
            currentNodesId: null,       //选中当前节点id
            treeData: [],               //tree 数据
            ztreeObj: null,             //tree 对象
            ztreeStyle: {},             //ztree节点 样式
            path:"",
            // 函数列表树配置
            setting: {
                data: {
                    simpleData: {
                        enable: true,
                        idKey: "id",
                        pIdKey: "parentId"
                    }
                },
                check: {
                    enable: false,
                },
                edit: {//是否允许移动节点
                    enable: false,
                    drag: {
                        isCopy: false,
                        isMove: false
                    }
                },
                callback: {
                    // 点击click事件
                    onClick: (event, treeId, treeNode) => {
                        // if (treeNode.type == "folder") return;
                        // 点击树节点勾选
                      this.path=treeNode.getPath().map(function (node) { return node.name; }).join('>');


                        if(this.showCheckbox){
                            this.ztreeObj.checkNode(treeNode, !treeNode.checked, true); 
                        }

                        this.clickTreeNode(event, treeId, treeNode)
                    },
                    // 双击事件
                    onDblClick: (event, treeId, treeNode) => {
                        // if (treeNode.type == "folder") return;
                        this.dblClickTreeNode(event, treeId, treeNode)
                    },
                    // 展开
                    onExpand: (event, treeId, treeNode) => {
                        this.onExpand(treeNode.name, treeNode.nData, treeNode.strData, treeNode.dbData);
                    },
                    // 关闭
                    onCollapse: (event, treeId, treeNode) => {
                        this.onExpand(treeNode.name, treeNode.nData, treeNode.strData, treeNode.dbData);
                    }
                },
                view: {
                    showIcon: true,
                    showLine: true,
                    fontCss : { //字体样式
                        color: '',
                    }
                }
            },
        }
    },
    computed:{
        treeGround(){
            return {
                position: "absolute",
                width: "100%",
                top: "0px",
            }
        }
    },
    methods : {
     getAllChildrenNodes(treeNode,result){
        
        var childrenNodes = treeNode.children;
        if(childrenNodes){
        for ( var i = 0; i < childrenNodes.length; i++) {
        if(childrenNodes[i].isParent){
        if(result == ''){
        result += childrenNodes[i].id;
        }else{
        result += '>' + childrenNodes[i].id;
        }
        }
        result = getAllChildrenNodes(childrenNodes[i],result);
        }
        }
        return result;
    },
        /**树菜单 */
        create(){
            this.mixin(this.primitives);
            this.windowsObject = this.$parent.$parent;
            //初始化位置
            this.TreeStyle = {
                left : 0 + "px",
                top : 0 + "px",
                width : 0 + "px",
                height : 0 + "px",
                overflowX : "auto",
                backgroundColor : this.backgroundColor || "transparent",
            }
            this.ztreeStyle = {
                fontSize: this.fontSize + "px",
                fontFamily: this.fontName,
                fontWeight: this.weight ? "bold" : "initial",
                fontStyle: this.italic ? "italic" : "initial"
            }
            this.enableStyle = {
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0px",
                backgroundColor: "#ccbfbf",
                opacity: "0.5"
            }
            this.setting.view.fontCss.color = this.fontColor;
            this.initData(this.treechildren.items);
            //添加数据到控件中
            //this.updateTree();
            if(this.Change && this.Change != "%Change%"){
                this.Change = AsyncFunction("strOldSelName","nOldData","strNewSelName","nNewData",this.Change);
            }
            if(this.DBClick && this.DBClick != "%DBClick%"){
                this.DBClick = AsyncFunction("strSelName","nData","strData","dbData",this.DBClick);
            }
            if(this.Click && this.Click != "%Click%"){
                this.Click = AsyncFunction("strSelName","nData","strData","dbData",this.Click);
            }
            if(this.Expand && this.Expand != "%Expand%"){
                this.Expand = AsyncFunction("strSelName","nData","strData","dbData",this.Expand);
            }
        },
        //初始化 数据， 给json数据添加cn字段，用于多语言切换 
        initData(arrData) {
            if(arrData !== null){
                if(arrData.length > 0){
                    for (var i = 0; i < arrData.length; i++) {
                        arrData[i]["cn"] = arrData[i].name;
                        if(arrData[i].children && arrData[i].children.length > 0){
                            this.initData(arrData[i].children);
                        };
                    };   
                };
            }
            
        },
        /**
         * 初始化创建ztreeobj
         */
        handleCreated(ztreeObj) {
            this.ztreeObj = ztreeObj;
        },
        updateTree(){
            if(this.treechildren && this.treechildren.items!==null){
                if(this.treechildren.items.length > 0){
                    this.translateData(this.treechildren.items);
                    this.treeData = this.treechildren.items;
                    // console.log(this.treeData)
                    // console.log(this.$store.state.system.$.resultData.userInfo)
                }
                
            }
        },
        //递归 数据遍历json 多语言实现
        translateData(arrData) {
            if(arrData.length > 0){
                for (var i = 0; i < arrData.length; i++) {
                    //判断当前的用户
                    //多语言key值为 中文的原始字段，
                    // if(i==4){
                    //     delete arrData[i];
                    //     continue;
                    // }
                    arrData[i].name = this.fvSystemApi.getResource(arrData[i].cn) || arrData[i].cn;
                    if(arrData[i].children && arrData[i].children.length > 0){
                        this.translateData(arrData[i].children);
                    };
                };   
            };
        },
        /**
         * click or change
         */
        clickTreeNode(event, treeId, treeNode){
            let oldNodes = this.currentNodes;
            this.currentNodes = treeNode;
            this.currentNodesId = treeNode.id;
            var name = treeNode.name;
            var nData = treeNode.nData;
            var strData = treeNode.strData;
            var dbData = treeNode.dbData;
            if(this.currentNodesId && this.currentNodesId != treeNode.id){
                this.onChange(oldNodes.name, oldNodes.nData, name, dbData);
            }
            this.onClick(name, nData, strData, dbData);
        },
        /**
         * dblClick
         */
        dblClickTreeNode(event, treeId, treeNode){
            if(!treeNode){
                return;
            }
            this.onDBClick(treeNode.name, treeNode.nData, treeNode.strData, treeNode.dbData);
        },
        
        /*
            参数：data 节点数据
            作用：闭合展开节点的 时候获取相应数据
        */
        onChange(strOldSelName,nOldData,strNewSelName,nNewData){
            if(typeof this.Change == "function"){
               this.fvSystemApi.executionScript(this.Change,strOldSelName,nOldData,strNewSelName,nNewData);
            }
        },
        onDBClick(strSelName,nData,strData,dbData){
            if(typeof this.DBClick == "function"){
               this.fvSystemApi.executionScript(this.DBClick,strSelName,parseInt(nData),strData.toString(),dbData.toString());
            }
        },
        onClick(strSelName,nData,strData,dbData){
            if(typeof this.Click == "function"){
               this.fvSystemApi.executionScript(this.Click,strSelName,parseInt(nData),strData.toString(),dbData.toString());
            }
        },
        onExpand(strSelName,nData,strData,dbData){
            if(typeof this.Expand == "function"){
               this.fvSystemApi.executionScript(this.Expand,strSelName,parseInt(nData),strData.toString(),dbData.toString());
            }
        },
        /*
            参数：0:关闭所有 1:展开所有节点
            作用：:展开节点
        */
        ExpandTree(isAllOpen){
            if(this.ztreeObj){
                this.ztreeObj.expandAll(isAllOpen);
            }
        },
        /*
            参数：无
            作用：获得树形菜单中被选中项中附带的数值
        */
        GetSelItemData(){
            if(this.currentNodes){
                var data = Number(this.currentNodes.nData);
                if(data == undefined){
                    this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"当前节点设置数据有误!":"The current node setup data is incorrect!");
                }else{
                    return this.currentNodes.nData;
                }
            }else{
                this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"无选中项！":"No selected items!");
            }
        },
        /*
            参数：无
            作用：获得树形菜单中被选中项的名称
        */
        GetSelItemName(){
            if(this.currentNodes){
                return this.currentNodes.name;
            }else{
                this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"无选中项！":"No selected items!");
            }
        },
        /*
            参数：无
            作用：获取属性菜单中被选中项的字符型数据
        */
        GetSelItemStrData(){
            if(this.currentNodes){
                return this.currentNodes.strData;
            }else{
                this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"无选中项！":"No selected items!");
            }
        },
        /*
            参数：无
            作用：获得树形菜单中被选中项的数据库点值数据
        */
        GetSelItemDbData(){
            if(this.currentNodes){
                return this.currentNodes.dbData;
            }else{
                this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"无选中项！":"No selected items!");
            }
        },

        /*
            参数：无
            作用：获取选中节点全路径
        */
        GetPath(){
            if(this.currentNodes){
                return this.path;
            }else{
                this.$Message.error(this.$store.state.system.$.languageName == "ch" ?"无选中项！":"No selected items!");
            }
        },
        /*
            参数：src ：外部属性（对象）
            作用：混淆属性
        */
        mixin(src) {
            for (var key in src) {
                this[key] = src[key]
            }
        },
        /*
            参数：e 鼠标信息
                 domScale 窗口放大、缩小、偏移等信息
            作用：鼠标事件调用函数，无必要可不进行任何处理
        */
        doFixedEvent(e,domScale){},
        /*
            参数：scaleObj 重绘信息
            作用：组件需要重绘时触发
        */
        reDraw(scaleObj){
            this.updateTree();
            // 文字大小通过render修改
            this.ztreeStyle.fontSize = PtToPx(parseInt(this.fontSize)) * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox + "px"; 
            this.TreeStyle.left = parseInt((this.x * (scaleObj.sx + scaleObj.zoom)) + scaleObj.ox) + "px";
            this.TreeStyle.top  = parseInt((this.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.oy) + "px";
            this.TreeStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + "px";
            this.TreeStyle.height = parseInt(this.height * (scaleObj.sy + scaleObj.zoom)) + "px";
            //产生随机字母 
            var ranNum = this.getRanNum();
            //给domo节点添加class
            this.$el.children[0].className +=" "+ranNum;
            $("."+ranNum+" .button").append('<style>.'+ranNum+' span.button.switch:before{border-color:transparent transparent transparent '+this.fontColor+' !important}</style>');
        },
        //生成随机数
        getRanNum(){
            var result = [];
                for(var i=0;i<4;i++){
                var ranNum = Math.ceil(Math.random() * 25); //生成一个0到25的数字
                    //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
                    result.push(String.fromCharCode(65+ranNum));
                }
            return  result.join('');
        },
        /*
            参数：无
            作用：系统周期调用
        */
        onTimer(){
            if(this.isEnable) return;
        },
        /*
            参数：isShow 显示隐藏
            作用：设置组件整体显隐
        */
        Show(isShow){
            this.isShow = isShow ? true:false;
        },
        /*
            参数：isEnable 是否可用
            作用：设置组件是否可用
        */
        Enable(isEnable){
            this.isEnable = isEnable ? false : true;
            if(this.isEnable){
                this.TreeStyle.overflow = "hidden";
            }else{
                this.TreeStyle.overflow = "auto";
            }
        },

    }
}
</script>
<style>
    .ztree .button{
        position: absolute;
        left: 0;
        top: inherit;
        width: inherit;
        height: inherit;
        z-index: inherit;
        background:inherit;
        border: inherit;
        border-radius: inherit;
    }
   .ztree .button {
    display: inline !important;
    width: 12px !important;
    height: 12px !important;
    margin-left: -1px;
    
}
span.button.switch:before{
    top:-1px !important;
} 
.ztree li a{
    margin-left:16px !important;
    
}
.ico_open{
    font-family: Ionicons !important; 
}
.node
.ztree li span.button.ico_open, .ztree li span.button.ico_close,
    .ztree li span.button.ico_docu{
        display: inline-block;
        font-family: Ionicons;
        speak: none;
        font-style: normal;
        font-weight: 400;
        font-variant: normal;
        text-transform: none;
        text-rendering: optimizeLegibility;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        vertical-align: -.125em;
        text-align: center;
    }

    .ztree li span.button.ico_open:before {
        content: "\F1D0";
    }

    .ztree li span.button.ico_close:before {
        content: "\F1D2";
	}
	.ztree li span.button.ico_docu:before {
        content: "\F252";
    }

    .ivu-vueTree-div {
        width : 100%;
        height : 100%;
        position: absolute;
        padding : 0;
    }
    .ivu-vueTree-div::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
    }

    .ivu-vueTree-div::-webkit-scrollbar
    {
        height: 6px;
        width : 6px;
        background-color: #F5F5F5;
    }

    .ivu-vueTree-div::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        background-image: -webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));
    }
    /*滚动条样式*/
    .vueTreeOverflow::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        border-radius: 10px;
        background-color: #F5F5F5;
    }

    .vueTreeOverflow::-webkit-scrollbar
    {
        height: 6px;
        width : 6px;
        background-color: #F5F5F5;
    }

    .vueTreeOverflow::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        background-image: -webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));
    }
    body{
        color : #000;
    }
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvTree/fvTree.vue